import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { PayrollStatus } from 'modules/payroll_bundle/lib/enums'

import { comparePaths } from './comparePaths'
import { PathSegment } from './types'

interface Options {
  path: string
  policyId: PathSegment
  policyPeriodId: PathSegment
  navigation: ReturnType<typeof useNavigation>['navigation']
}
export function usePolicyPeriodStatusForLocation({
  path,
  policyId,
  policyPeriodId,
  navigation,
}: Options) {
  const status = useUnsafeMemo(() => {
    if (
      comparePaths(
        path,
        navigation.payrollBundle.policy.period.cycles.supplements.fullPath({
          policyId,
          periodId: policyPeriodId,
        })
      )
    ) {
      return PayrollStatus.UNDER_REVIEW
    }

    if (
      comparePaths(
        path,
        navigation.payrollBundle.policy.period.cycles.results.fullPath({
          policyId,
          periodId: policyPeriodId,
        })
      )
    ) {
      return PayrollStatus.PAYROLL_CALCULATION
    }

    if (
      comparePaths(
        path,
        navigation.payrollBundle.policy.period.cycles.payments.fullPath({
          policyId,
          periodId: policyPeriodId,
        })
      )
    ) {
      return PayrollStatus.PAID
    }

    return null
  }, [path, policyId, policyPeriodId, navigation])

  return status
}
